function viewport() {
  return window.getComputedStyle(document.body, ':after').getPropertyValue('content').replace(/["']/g, '');
}

export default viewport;
